import { AddItem, Image, TextButton, Thumbnail } from '@wix/design-system';
import { useFilePicker } from 'hooks/useFilePicker';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectImageStep.scss';
import { urlUtils } from 'utils/url';
import { ReplaceSmall } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';

type Props = {
  isSelected: boolean;
  onSelect: () => void;
};

export const SelectImageStepUpload: FC<Props> = ({ isSelected, onSelect }) => {
  const { t } = useTranslation();

  const localFile = useAppStore((state) => state.localFile);
  const setLocalFile = useAppStore((state) => state.setLocalFile);
  const safeFileUrl = localFile && urlUtils.createSafeFileUrl(localFile);

  const { openFilePicker } = useFilePicker({
    onFilePicked: (file) => {
      setLocalFile(file);
      onSelect();
    },
  });

  return (
    <div className={styles.selectImageStepUpload}>
      <div className={styles.selectImageStepUploadMedia}>
        {safeFileUrl ? (
          <Thumbnail onClick={onSelect} selected={isSelected}>
            <Image transparent width="100%" height="100%" src={safeFileUrl} alt={safeFileUrl} fit="contain" />
          </Thumbnail>
        ) : (
          <AddItem onClick={openFilePicker} size="small" subtitle={t('select-image-step.upload.add-item.subtitle')}>
            {t('select-image-step.upload.add-item.caption')}
          </AddItem>
        )}
      </div>
      {safeFileUrl && (
        <TextButton size="small" prefixIcon={<ReplaceSmall />} onClick={openFilePicker}>
          {t('select-image-step.upload.replace-image')}
        </TextButton>
      )}
    </div>
  );
};
